/** PURE_IMPORTS_START .._.._Observable,.._.._operator_repeat PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { repeat } from '../../operator/repeat';
Observable.prototype.repeat = repeat;
//# sourceMappingURL=repeat.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/repeat.js
// module id = 553
// module chunks = 0